export default {
  // logging: 'Logging...',
  // logCall: 'Log Call',
  // editLog: 'Edit Log',
  // select: 'Select a matching record',
  // OnHold: 'On Hold',
  // Ringing: 'Ringing',
  // CallConnected: 'Call Connected',
  // unknownUser: 'Unknown User',
  // unknownNumber: 'Anonymous',
  // unavailable: 'Unavailable',
  // viewDetails: 'View Details',
  // addEntity: 'Create New',
  // addLog: 'Log',
  // text: 'Text',
  // call: 'Call',
  // addContact: 'Add Contact',
  missedCall: 'Missed',
  inboundCall: 'Inbound',
  outboundCall: 'Outbound',
  // from: 'From',
  // to: 'To',
  // hangup: 'Hangup',
  // accept: 'Accept',
  // toVoicemail: 'Send to Voicemail',
  // anonymous: 'Anonymous',
  // mergeToConference: 'Merge',
  // hold: 'Hold',
  // unhold: 'Unhold',
} as const;
